import { render } from "./SettingCardControl.vue?vue&type=template&id=dad0d3b6&scoped=true"
import script from "./SettingCardControl.vue?vue&type=script&lang=js"
export * from "./SettingCardControl.vue?vue&type=script&lang=js"

import "./SettingCardControl.vue?vue&type=style&index=0&id=dad0d3b6&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dad0d3b6"]])

export default __exports__